import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Stop } from './consolidator.component';

@Component({
  selector: 'app-select-stop-dialog',
  template: `
    <h1 mat-dialog-title>Select Stop</h1>
    <div mat-dialog-content>
      <mat-list>
        <mat-list-item *ngFor="let stop of data.stops" (click)="onSelect(stop)">
          Stop #{{ stop.stopNumber }} - {{ stop.consignee }}
        </mat-list-item>
      </mat-list>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
    </div>
  `
})
export class SelectStopDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SelectStopDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { stops: Stop[] }
  ) {}

  onSelect(stop: Stop) {
    this.dialogRef.close(stop);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}